import type { SVGProps } from "react";
export default function SvgList(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-list-icon lucide-list"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M3 5h.01" />
			<path d="M3 12h.01" />
			<path d="M3 19h.01" />
			<path d="M8 5h13" />
			<path d="M8 12h13" />
			<path d="M8 19h13" />
		</svg>
	);
}
